import { FlashbarProps } from "@amzn/awsui-components-react-v3";

import { callSNOWDataService } from "src/utils/snowDataServiceWrapper";
import { logger } from "src/utils/logger";
import { getApiErrorMessage } from "src/utils/CommonUtils";
import {
  KeyAnyValuePairsObject,
  KeyStringValuePairsObject,
} from "src/@types/common";

import useStateObject from "./useStateObject";

export interface UseFetchState<T> {
  isLoading: boolean;
  data: T | null;
  error: string | null;
  flashBarItems: FlashbarProps.MessageDefinition[];
}

export interface OnClickCBRequestProps {
  path: string;
  headers?: KeyStringValuePairsObject;
  queryParams?: KeyAnyValuePairsObject;
  method?: string;
  body?: KeyAnyValuePairsObject;
  url?: string;
  credentials?: KeyStringValuePairsObject;
  signal?: AbortSignal;
}

const useFetchOnUserActionUsingSDS = <T>() => {
  const [result, setResult] = useStateObject<UseFetchState<T>>({
    isLoading: false,
    data: null,
    error: null,
    flashBarItems: [],
  });

  const onClickCB = async <T>(
    requestProps: OnClickCBRequestProps,
    onSuccessCB = (e) => e
  ) => {
    const { path } = requestProps;
    setResult({
      isLoading: true,
      data: null,
      error: null,
      flashBarItems: [],
    });
    logger.info("useOnClickFetchForSDS hook called" + path);

    try {
      const response = await callSNOWDataService(requestProps as any);
      const contextToLog = {
        path: path,
        data: response,
      };
      logger.info(
        "useOnClickFetchForSDS hook returned successfully",
        contextToLog
      );
      const parsedResponse = onSuccessCB(response);
      setResult({
        isLoading: false,
        data: parsedResponse,
        error: null,
        flashBarItems: [],
      });
      return response;
    } catch (error) {
      logger.error(
        "useOnClickFetchForSDS hook called for API path:" +
          path +
          " returned error" +
          JSON.stringify(error)
      );
      const userReadableError = getApiErrorMessage(error);
      setResult({
        isLoading: false,
        data: null,
        error: userReadableError,
        flashBarItems: [
          {
            type: "error",
            header: userReadableError,
            dismissible: true,
            onDismiss: () => setResult({ flashBarItems: [], error: "" }),
          },
        ],
      });
      return { error: userReadableError };
    }
  };
  return { result, setResult, onClickCB };
};

export default useFetchOnUserActionUsingSDS;
